import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

// Components
import Loader from '../../components/Loader';
import Payment from '../../components/Payment';
import NotFound from '../notFound/NotFound';
import { withQuery } from '../../hoc/withGraphql';

// GraphQl
import getPaymentDataQuery from './getPaymentData.graphql';

import s from './Payment.css';

const PaymentContainer = (props) => {

  const { paymentData: { loading, getPaymentData } } = props;

  if (!loading && !getPaymentData) {
    return <NotFound />
  }

  return (
    <div className={s.root}>
      <div className={s.container}>
        {
          loading ? <Loader type={"text"} /> : <Payment data={getPaymentData} />
        }
      </div>
    </div>
  );
}

PaymentContainer.propTypes = {
  reservationId: PropTypes.number.isRequired,
  paymentData: PropTypes.shape({
    loading: PropTypes.bool,
    getPaymentData: PropTypes.object
  })
};

export default compose(
  withStyles(s),
  withQuery(getPaymentDataQuery,
    {
      name: 'paymentData',
      options: (props) => ({
        variables: {
          reservationId: props.reservationId,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(PaymentContainer);
